import { useHistory } from 'react-router-dom';

import styles from './index.module.css'
import collectLinkStoneImg from '../../../../statics/collect_linkstone.png'


const NoneContentBox = () => {
    let history = useHistory();

    const redirectAndAddNewTopic = () => {
        // this.props.history.push({pathname: '/home'})
        history.push('/home')
    }

    return (
        <div className={styles.container}>
            <img src={collectLinkStoneImg} className={styles.none_img} />

            <div className={styles.none_text}>
                你还没有任何收藏的对话记录
            </div>

            <div className={styles.none_explain}>
                你收藏的历史聊天记录将会被储存在这里！让我们开始聊天吧！
            </div>

            <div
                className={styles.create_butn}
                onClick={redirectAndAddNewTopic}>
                创建新对话
            </div>
        </div>
    )
}

export default NoneContentBox